import { selectFromConfig } from '@gandi/redux-config';
import { createResource } from '@gandi/resource/redux';
import { createLogger } from 'gandi.redux-logger';
const logger = createLogger('Contracts');
export const contracts = createResource('contracts');
export const computeLabel = params => Object.values(params).filter(el => typeof el !== 'boolean').sort().join('-');
export const fetchContracts = args => (dispatch, getState) => {
  const state = getState();
  const appConfig = selectFromConfig('app', {})(state);
  const publicUrl = selectFromConfig('public_url', {})(state);
  const {
    contractId,
    contractName,
    buId,
    sharingId,
    productId,
    dedup = true,
    sortBy
  } = args;
  const params = {
    for: contractId,
    '~name': contractName,
    bu_id: buId,
    sharing_id: sharingId,
    product_id: productId,
    deduplicate: dedup,
    sort_by: sortBy
  };
  return dispatch(contracts.fetch('/contract/contracts', {
    params,
    label: computeLabel(args),
    headers: {
      'Hateoas-Prefix': `${appConfig.layout.prefixes.contracts}`,
      'Hateoas-Replace': `${publicUrl}${appConfig.endpoint}`
    },
    on200: response => response,
    not200: response => {
      const fields = {
        res: response,
        statusCode: response.status
      };
      switch (response.status) {
        case 403:
          dispatch(logger.warn(fields, 'No permissions to fetch contracts'));
          break;
        case 500:
          dispatch(logger.fatal(fields, 'Cannot fetch contracts'));
          break;
        default:
          dispatch(logger.error(fields, 'Cannot fetch contracts'));
      }
      return Promise.reject(response);
    }
  }));
};